var React = require('react');

function IcSchedule (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.125 2.679h.67c.736 0 1.339.602 1.339 1.339v9.375c0 .736-.603 1.34-1.34 1.34H3.42c-.736 0-1.339-.604-1.339-1.34V4.018c0-.737.603-1.34 1.34-1.34h.669V1.34h1.34v1.34h5.356v-1.34h1.34v1.34zM3.419 13.393h9.374V6.696H3.42v6.697zm0-8.036v-1.34h9.374v1.34H3.42zm5.103 7.017h-.831V10.46H5.777V9.63H7.69V7.715h.831v1.914h1.914v.831H8.522v1.914z","fill":"currentColor"}));
}

IcSchedule.defaultProps = {"fill":"none","viewBox":"0 0 17 17"};

module.exports = IcSchedule;

IcSchedule.default = IcSchedule;
